import React, { useState } from 'react';
import { MemberRole, PermanentInjury, WarbandMemberDTO } from '../../types';
import { SelectPermanentInjuryModal, SelectablePermanentInjury } from '../modals/SelectPermanentInjuryModal';
import { useReferenceDataStore } from '../../stores/referenceDataStore';
import { PermanentInjuries } from './PermanentInjuries';

interface MemberPermanentInjuriesProps {
  injuries: PermanentInjury[];
  editMode?: boolean;
  memberRole?: MemberRole;
  member?: WarbandMemberDTO;
  onUpdateInjuries?: (injuryIds: string[]) => void;
}

export const MemberPermanentInjuries: React.FC<MemberPermanentInjuriesProps> = ({
  injuries,
  editMode = false,
  memberRole,
  member,
  onUpdateInjuries,
}) => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const canEdit = editMode && memberRole !== 'soldier' && !!onUpdateInjuries;
  const availableInjuries = useReferenceDataStore((state) => state.injuries);

  if (!canEdit && injuries.length === 0) return null;

  return (
    <>
      <PermanentInjuries
        injuries={injuries.map((injury) => ({
          id: injury.id,
          name: injury.name,
          description: injury.description,
          effectLabel: [
            injury.fightChange != null ? `Fight ${injury.fightChange > 0 ? '+' : ''}${injury.fightChange}` : null,
            injury.shootChange != null ? `Shoot ${injury.shootChange > 0 ? '+' : ''}${injury.shootChange}` : null,
            injury.moveChange != null ? `Move ${injury.moveChange > 0 ? '+' : ''}${injury.moveChange}` : null,
            injury.willChange != null ? `Will ${injury.willChange > 0 ? '+' : ''}${injury.willChange}` : null,
            injury.healthChange != null ? `Health ${injury.healthChange > 0 ? '+' : ''}${injury.healthChange}` : null,
            injury.castingNumberChange != null ? `Casting ${injury.castingNumberChange > 0 ? '+' : ''}${injury.castingNumberChange}` : null,
          ].filter(Boolean).join(', ') || undefined,
        }))}
        editMode={canEdit}
        onAdd={canEdit ? () => setIsAddModalOpen(true) : undefined}
        onRemove={canEdit ? (_, index) => onUpdateInjuries!(injuries.filter((_, i) => i !== index).map((injury) => injury.id)) : undefined}
      />

      {canEdit && (
        <SelectPermanentInjuryModal
          open={isAddModalOpen}
          memberName={member?.name ?? ''}
          injuries={availableInjuries.map((injury): SelectablePermanentInjury => ({
            id: injury.id,
            name: injury.name,
            description: injury.description,
            effectLabel: [
              injury.fightChange != null ? `Fight ${injury.fightChange > 0 ? '+' : ''}${injury.fightChange}` : null,
              injury.shootChange != null ? `Shoot ${injury.shootChange > 0 ? '+' : ''}${injury.shootChange}` : null,
              injury.moveChange != null ? `Move ${injury.moveChange > 0 ? '+' : ''}${injury.moveChange}` : null,
              injury.willChange != null ? `Will ${injury.willChange > 0 ? '+' : ''}${injury.willChange}` : null,
              injury.healthChange != null ? `Health ${injury.healthChange > 0 ? '+' : ''}${injury.healthChange}` : null,
              injury.castingNumberChange != null ? `Casting Numbers ${injury.castingNumberChange > 0 ? '+' : ''}${injury.castingNumberChange}` : null,
            ].filter(Boolean).join(', ') || undefined,
          }))}
          onClose={() => setIsAddModalOpen(false)}
          onSelect={(injury) => {
            onUpdateInjuries!([...injuries.map((i) => i.id), injury.id]);
            setIsAddModalOpen(false);
          }}
        />
      )}

    </>
  );
};
